import {
  useState, useContext, useEffect,
} from 'react';
import ExpandirMenu from '../../assets/img/sidebar/ExpandirMenu.svg';
import MenuExpandido from '../../assets/img/sidebar/MenuExpandido.svg';
import { withRouter } from 'react-router';
import { t } from 'i18next';
import Configuracoes from '../../assets/img/sidebar/configuracoes.svg';
import { PoweredByDiel } from '../PoweredByDiel';
import Analise from '../../assets/img/sidebar/NovoAnalise.svg';
import ClientPanelIcon from '../../assets/img/sidebar/NovoClientPanel.svg';
import Alertas from '../../assets/img/sidebar/Alertas.svg';
import Usuarios from '../../assets/img/sidebar/NovoUsuarios.svg';
import Help from '../../assets/img/sidebar/help-circle.svg';
import { getUserProfile } from '../../helpers/userProfile';
import MenuContext from '../../contexts/menuContext';
import CelsiusAiContext from '../../contexts/celsiusAiContext';
import { useLocation } from 'react-router-dom';
import homeIcon from '../../assets/img/sidebar/Home.svg';
import {
  BuildingIcon,
  EvaporatorIcon,
  EnvironmentsIcon,
  LightningIcon,
  DeviceIcon,
  ToolIcon,
  ToolPredictiveIcon,
  SignalIcon,
  WaterIcon,
} from '../../icons/sidebar';
import { ChevronIcon } from '../../icons/Chevron';
import {
  StyledLink,
  Background,
  LogoContainer,
  CustomLogo,
  MenuItem,
  MenuHighlight,
  MenuItemImg,
  MenuItemName,
  SubItemMenu,
  SubItemIcon,
  SubItemHighlight,
  AnaliseChevron,
  BorderSubItem,
  MenuSubItemName,
  ContainerSubItem,
  BorderHorizontalSubItem,
  Creditos,
  InfoHeader, ModalTitle,
  ModalSubTitle,
  ModalCancel,
  AcceptationModalSubTitle,
  AcceptationModalButton,
  HorizontalLine,
  NotificationBadge,
  NewBadge,
} from './styles';
import { ModalWindow } from '../ModalWindow';
import { Flex } from 'reflexbox';
import { Button } from '../Button';
import { DraggableArea } from './Draggable/DraggableArea';
import { toast } from 'react-toastify';
import { apiCall } from '../../providers';
import { ICard, useCard } from '../../contexts/CardContext';
import { AlertSignalIcon } from '../../icons';
import { TourPopover } from '../TourPopover';
import { useTour } from '../../contexts/TourContext';
import { useStateVar } from '~/helpers/useStateVar';
import { identifyUser } from '~/helpers/posthogHelper';
import SelectPlataformContext from '../../contexts/selectPlataform';
import { BsThermometer } from 'react-icons/bs';

interface IClicked {
  highlight: boolean,
  background: boolean
}

const Menu = ({ history }) => {
  const isSubItem = true;
  const isVisible = true;
  const { pathname } = useLocation();

  const { cards, dispatch } = useCard();
  const [profile] = useState(getUserProfile);
  const [prevCards, setPrevCards] = useState<ICard[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [toogleAnalise, setToogleAnalise] = useState(false);
  const [toggleAlerts, setToggleAlerts] = useState(false);
  const [isConfirmation, setIsConfirmation] = useState(false);
  const { menuToogle, setMenuToogle } = useContext(MenuContext);// true = open, false = not Open
  const { setIsCelsiusOpen } = useContext(CelsiusAiContext);
  const [isClickedAnalise, setIsClicked] = useState<IClicked>({ highlight: false, background: false });
  const [isClickedAlerts, setIsClickedAlerts] = useState<IClicked>({ highlight: false, background: false });
  const { selectPlataform } = useContext(SelectPlataformContext);

  const selectRemoteControl = selectPlataform === '/controle-inteligente';

  const isClientToPredictiveDashboard = profile.permissions.PER_CLIENT.some((item) => [145, 149, 152, 136].includes(item.clientId)) && !profile.permissions.isInstaller;
  const isClientToWaterDashboard = profile.permissions.PER_CLIENT.some((item) => item.clientId === 152) && !profile.permissions.isInstaller;
  const perUnitUnits = profile.permissions.PER_UNIT?.flatMap((x) => x.units) ?? [];
  const hasSingleUnitAccess = profile.permissions.PER_CLIENT.length === 0 && perUnitUnits.length === 1;
  const isAllowClientNewOverview = !profile.permissions.isInstaller && !selectRemoteControl && !hasSingleUnitAccess;

  const [state, render] = useStateVar(() => ({
    countNotifications: 0 as number,
  }));

  function toggleModal() {
    setPrevCards(cards);
    setIsConfirmation(false);
    setIsModalOpen((prevState) => !prevState);
  }

  function toggleConfirmation() {
    setIsConfirmation((prevState) => !prevState);
  }

  const handleSubmitModal = () => {
    dispatch({ type: 'SAVE_STATE' });
    toast.success('Cards salvos com sucesso!');
    setIsConfirmation(false);
    setIsModalOpen(false);
  };

  function handleCancelModal() {
    localStorage.setItem('cards', JSON.stringify(prevCards));
    dispatch({ type: 'RESET_ALL', payload: prevCards });
    setIsConfirmation(false);
    setIsModalOpen(false);
  }

  type SidebarIcon = React.ComponentType<{ color?: string; size?: number | string }>;

  function getMenuSubItemAnalise(name: string, link: string, isVisible: boolean, Icon?: SidebarIcon, isNewOption?: boolean) {
    return {
      newOption: !!(isNewOption && isVisible === true),
      menuToogle,
      linkTo: link,
      subItem: isSubItem,
      isVisible,
      name,
      Icon,
      isActive: history.location.pathname.includes(link),
      click: () => setIsClicked(() => ({ highlight: false, background: true })),
    };
  }
  function getMenuSubItemNotif(name: string, link: string, isVisible: boolean) {
    return {
      menuToogle,
      linkTo: link,
      subItem: isSubItem,
      isVisible,
      name,
      isActive: history.location.pathname.includes(link),
      click: () => setIsClickedAlerts(() => ({ highlight: false, background: true })),
    };
  }
  const subItemsAnalise = [
    getMenuSubItemAnalise(t('unidades'), '/analise/unidades', isVisible, BuildingIcon),
    getMenuSubItemAnalise(t('manutencao'), '/analise/manutencao', isVisible, ToolIcon),
    getMenuSubItemAnalise(t('confortoTermico'), '/analise/conforto-termico', !!profile.permissions.isAdminSistema, BsThermometer),
    getMenuSubItemAnalise(t('maquinas'), '/analise/maquinas', isVisible, EvaporatorIcon),
    getMenuSubItemAnalise(t('ambientes'), '/analise/ambientes', isVisible, EnvironmentsIcon),
    getMenuSubItemAnalise(t('energia'), '/analise/energia', isVisible, LightningIcon),
    getMenuSubItemAnalise(t('dispositivos'), '/analise/dispositivos', isVisible, DeviceIcon),
    getMenuSubItemAnalise(t('utilitarios'), '/analise/utilitarios', isVisible, ToolIcon),
    getMenuSubItemAnalise(t('preditivo'), '/analise/preditivo', isClientToPredictiveDashboard || false, ToolPredictiveIcon),
    getMenuSubItemAnalise(t('agua'), '/analise/agua', isClientToWaterDashboard || false, WaterIcon),
    getMenuSubItemAnalise(t('conectividade'), '/analise/conectividade', isVisible, SignalIcon),
  ];

  const hasNewSubItem = subItemsAnalise.some((item) => item.newOption);

  const subItemsAlerts = [
    getMenuSubItemNotif('Feed', '/alertas/feed', isVisible),
    getMenuSubItemNotif('Histórico', '/alertas/historico', isVisible),
    getMenuSubItemNotif('Gerenciamento', '/alertas/gerenciamento', isVisible),
  ];

  useEffect(() => {
    if (menuToogle && (history.location.pathname.includes('/analise') || history.location.pathname.includes('/integracoes'))) {
      setIsClicked({ background: true, highlight: false });
      setToogleAnalise(true);
    }
    if (menuToogle && (history.location.pathname.includes('/alertas'))) {
      setIsClickedAlerts({ background: true, highlight: false });
      setToggleAlerts(true);
    }
    if (menuToogle) {
      setIsCelsiusOpen(false);
    } else {
      setToogleAnalise(false);
      setToggleAlerts(false);
      setIsClicked({ highlight: false, background: false });
      setIsClickedAlerts({ highlight: false, background: false });
    }
    localStorage.setItem('menuDiel', menuToogle.toString());
  }, [menuToogle]);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        if (profile.permissions.isPersonaII) return;
        const dataResponse = await apiCall('/mainservice/notifications/get-count-notifications', {});
        state.countNotifications = dataResponse;
        render();
      } catch (err) {
        console.log(err);
        toast.error(t('naoFoiPossivelCarregarDadosAlertas'));
      }
      render();
    };
    fetchCount();
  }, [pathname]);

  const menuIsActive = (links: string[]) => !menuToogle && links.some((link) => history.location.pathname.includes(link));
  const menuLinkIsActive = (link: string) => history.location.pathname.includes(link) && !isClickedAnalise.background && !isClickedAlerts.background;

  useEffect(() => {
    identifyUser(profile);
  }, []);

  const {
    tour, isTourActive, stepHistory,
  } = useTour();
  const firstStep = tour.findIndex((item) => item.step === 0);
  const secoundStep = tour.findIndex((item) => item.step === 1);
  const thirdStep = tour.findIndex((item) => item.step === 2);

  useEffect(() => {
    if (tour[0].isActive || tour[secoundStep].isActive || tour[firstStep].isActive) {
      setIsModalOpen(false);
    }

    if ((stepHistory[0] === 2 || stepHistory[0] === 3) && !isModalOpen) {
      setIsModalOpen(true);
    }
  }, [stepHistory, secoundStep, tour, isModalOpen]);

  function getLinkSupport() {
    const message = encodeURIComponent(t('mensagemSuporteWhatsapp'));
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    return isMobile
      ? `https://api.whatsapp.com/send?phone=${process.env.REACT_APP_SUPPORT_NUMBER}&text=${message}`
      : `https://web.whatsapp.com/send?phone=${process.env.REACT_APP_SUPPORT_NUMBER}&text=${message}`;
  }
  return (
    <Background isOpen={menuToogle}>
      <>
        <MenuLogo
          menuToogle={menuToogle}
          setMenuToogle={setMenuToogle}
          setToogleAnalise={setToogleAnalise}
          setToggleAlerts={setToggleAlerts}
        />
        <MenuLink
          menuToogle={menuToogle}
          linkTo="/nova-visao-geral"
          image={homeIcon}
          altImage="inicio"
          name={t('inicio')}
          isActive={menuLinkIsActive('/nova-visao-geral')}
          visible={isAllowClientNewOverview}
          click={() => {
            setIsClicked(() => ({ highlight: false, background: false }));
            setIsClickedAlerts(() => ({ highlight: false, background: false }));
            setToogleAnalise(false);
            setToggleAlerts(false);
          }}
        />
        <MenuLink
          menuToogle={menuToogle}
          image={homeIcon}
          altImage={t('controleInteligente')}
          name={t('paginaInicial')}
          isActive={menuLinkIsActive('/controle-inteligente')}
          linkTo="/controle-inteligente"
          visible={selectRemoteControl && !profile.permissions.isAdminSistema}
          click={() => {
            setIsClicked(() => ({ highlight: false, background: false }));
            setIsClickedAlerts(() => ({ highlight: false, background: false }));
            setToogleAnalise(false);
            setToggleAlerts(false);
          }}
        />
        <MenuItem
          isActive={isClickedAnalise.background || menuIsActive(['/analise', 'integracoes'])}
          isOpen={menuToogle}
          visible={!selectRemoteControl}
          onClick={() => {
            if (menuToogle) {
              // tirar seleçao de Análise
              setToogleAnalise(!toogleAnalise);
              if (!toogleAnalise) {
                setIsClicked(() => ({ highlight: true, background: true }));
              }
              else {
                setIsClicked(() => ({ highlight: false, background: false }));
              }
            }
            else {
              setMenuToogle(true);
              setIsClicked(() => ({ highlight: true, background: true }));
              setToogleAnalise(true);
            }
            setIsClickedAlerts(() => ({ highlight: false, background: false }));
            setToggleAlerts(false);
          }}
        >
          <MenuItemImg src={Analise} alt={t('analise')} />
          {menuToogle && <MenuItemName>{t('analise')}</MenuItemName>}
          {(hasNewSubItem && !toogleAnalise) && <NewBadge style={{ fontSize: '14px' }}>{t('novo')}</NewBadge>}
          {menuToogle && (
            <AnaliseChevron>
              <ChevronIcon size="14" rotate={toogleAnalise ? '90deg' : '-90deg'} />
            </AnaliseChevron>
          )}
        </MenuItem>
        { (toogleAnalise && !selectRemoteControl) && (
        <ContainerSubItem>
          {
            subItemsAnalise.map((item, index) => (
              item.isVisible && (
                <MenuLink
                  key={index + item.name}
                  menuToogle={item.menuToogle}
                  linkTo={item.linkTo}
                  name={item.name}
                  Icon={item.Icon}
                  isActive={item.isActive}
                  click={item.click}
                  subItem={item.subItem}
                  visible={isVisible}
                  isNew={item.newOption}
                />
              )
            ))
          }
          <BorderSubItem />
        </ContainerSubItem>
        )}
        <StyledLink to="/alertas/feed">
          <MenuItem
            isActive={isClickedAlerts.background || menuIsActive(['/alertas'])}
            isOpen={menuToogle}
            visible={!selectRemoteControl}
            onClick={() => {
              if (menuToogle) {
                setToggleAlerts(!toggleAlerts);
                if (!toggleAlerts) {
                  setIsClickedAlerts(() => ({ highlight: true, background: true }));
                }
                else {
                  setIsClickedAlerts(() => ({ highlight: false, background: false }));
                }
              } else {
                setMenuToogle(true);
                setIsClickedAlerts(() => ({ highlight: true, background: true }));
                setToggleAlerts(true);
              }
              setIsClicked(() => ({ highlight: false, background: false }));
              setToogleAnalise(false);
            }}
          >
            <MenuItemImg src={Alertas} alt={t('alertas')} />
            <MenuItemName>
              {menuToogle && (
                <>
                  {t('alertas')}
                </>
              )}
              {state.countNotifications > 0 && (
              <NotificationBadge
                menuToogle={menuToogle}
                isPlus={state.countNotifications > 99}
              >
                {state.countNotifications > 99 ? '+99' : state.countNotifications}
              </NotificationBadge>
              )}
            </MenuItemName>

          </MenuItem>
        </StyledLink>
        {(toggleAlerts && !selectRemoteControl) && (
        <ContainerSubItem>
          {
                subItemsAlerts.map((item, index) => (
                  item.isVisible && (
                    <MenuLink
                      key={item.name}
                      menuToogle={item.menuToogle}
                      linkTo={item.linkTo}
                      name={item.name}
                      isActive={item.isActive}
                      click={item.click}
                      subItem={item.subItem}
                      visible={isVisible}
                    />
                  )
                ))
              }
          <BorderSubItem style={{ height: '82%' }} />
        </ContainerSubItem>
        )}
        <MenuLink
          menuToogle={menuToogle}
          linkTo="/usuarios"
          image={Usuarios}
          altImage={t('usuarios')}
          name={t('usuarios')}
          isActive={menuLinkIsActive('/usuarios')}
          visible={!profile.permissions.isInstaller && !selectRemoteControl}
          click={() => {
            setIsClicked(() => ({ highlight: false, background: false }));
            setIsClickedAlerts(() => ({ highlight: false, background: false }));
            setToogleAnalise(false);
            setToggleAlerts(false);
          }}
        />
        <MenuLink
          menuToogle={menuToogle}
          linkTo="/faq-controle-remoto"
          image={Help}
          altImage={t('ajuda')}
          name={t('ajuda')}
          isActive={menuLinkIsActive('/faq-controle-remoto')}
          visible={selectRemoteControl}
          click={() => {
            setIsClicked(() => ({ highlight: false, background: false }));
            setIsClickedAlerts(() => ({ highlight: false, background: false }));
            setToogleAnalise(false);
            setToggleAlerts(false);
          }}
        />
        {/* {profile.permissions.isAdminSistema && (
          <MenuLink
            menuToogle={menuToogle}
            linkTo="/visita-tecnica"
            name="Instalação"
            image={VisitaTecnica}
            altImage={t('visitaTecnica')}
            isActive={menuLinkIsActive('/visita-tecnica')}
            visible={profile.permissions.isAdminSistema}
            click={() => {
              setIsClicked(() => ({ highlight: false, background: false }));
              setIsClickedNotificacoes(() => ({ highlight: false, background: false }));
              setToogleAnalise(false);
              setToggleNotificacoes(false);
            }}
          />
        )} */}
        { menuToogle
            && (
            <LogoContainer isOpen={menuToogle}>
              <InfoHeader>
                {t('CONTA')}
              </InfoHeader>
            </LogoContainer>
            )}
        { !menuToogle && (<div style={{ marginBottom: '35px' }} />)}
        <MenuLink
          menuToogle={menuToogle}
          linkTo="/painel/clientes/listagem"
          image={ClientPanelIcon}
          altImage={t('painel')}
          name={t('painel')}
          isActive={menuLinkIsActive('/painel')}
          visible={!!profile.manageAllClients || !!profile.permissions.isAdminConta}
          click={() => {
            setIsClicked(() => ({ highlight: false, background: false }));
            setIsClickedAlerts(() => ({ highlight: false, background: false }));
            setToogleAnalise(false);
            setToggleAlerts(false);
          }}
        />
        <MenuLink
          menuToogle={menuToogle}
          image={ClientPanelIcon}
          isActive={menuLinkIsActive('/painel')}
          name={t('painel')}
          linkTo="/painel/client-painel"
          altImage={t('painel')}
          visible={(!profile.manageAllClients && !profile.permissions.isAdminConta) && (profile.manageSomeClient) && !profile.permissions.isInstaller || false}
          click={() => {
            setIsClicked(() => ({ highlight: false, background: false }));
            setIsClickedAlerts(() => ({ highlight: false, background: false }));
            setToogleAnalise(false);
            setToggleAlerts(false);
          }}
        />
        <MenuLink
          menuToogle={menuToogle}
          image={Configuracoes}
          isActive={menuLinkIsActive('/configuracoes')}
          name={t('configuracoes')}
          linkTo="/configuracoes"
          altImage={t('configuracoes')}
          visible={isVisible}
          click={() => {
            setIsClicked(() => ({ highlight: false, background: false }));
            setIsClickedAlerts(() => ({ highlight: false, background: false }));
            setToogleAnalise(false);
            setToggleAlerts(false);
          }}
        />
        <Creditos>
          <PoweredByDiel showText={menuToogle} />
        </Creditos>
      </>
      {isModalOpen && (
        <ModalWindow
          borderTop
          style={{ width: '400px' }}
        >
          {isConfirmation ? (
            <>
              <Flex flexDirection="column" alignItems="flex-start" justifyContent="center" padding="16px">
                <Flex flexDirection="row" width="100%">
                  <AlertSignalIcon />
                  <Flex flexDirection="column" alignItems="flex-start" justifyContent="center" ml="8px">
                    <ModalTitle>
                      {t('gerenciarLista')}
                    </ModalTitle>
                    <AcceptationModalSubTitle>{t('voceTemCertezaCards')}</AcceptationModalSubTitle>
                  </Flex>
                </Flex>
              </Flex>
              <Flex justifyContent="center" alignItems="center" flexDirection="row" width="100%" style={{ gap: '8px' }}>
                <AcceptationModalButton onClick={handleSubmitModal} variant="primary">{t('botaoSalvar')}</AcceptationModalButton>
                <AcceptationModalButton onClick={handleCancelModal} variant="borderblue">{t('botaoSairSemSalvar')}</AcceptationModalButton>
              </Flex>
            </>
          ) : (
            <>
              <Flex flexDirection="column" alignItems="flex-start" justifyContent="center">
                <ModalTitle>
                  {t('gerenciarLista')}
                </ModalTitle>
                <ModalSubTitle>{t('gerenciarListaDescricao')}</ModalSubTitle>
              </Flex>
              <HorizontalLine />
              {isTourActive ? (
                <TourPopover tour={tour[thirdStep]} placement="left">
                  <DraggableArea closeModal={() => setIsModalOpen((state) => false)} />
                </TourPopover>
              ) : (
                <DraggableArea closeModal={() => setIsModalOpen((state) => false)} />
              )}
              <HorizontalLine />
              <Flex justifyContent="space-between" alignItems="center" flexDirection="row" width="100%">
                <ModalCancel style={{ cursor: 'pointer' }} onClick={prevCards === cards ? toggleModal : toggleConfirmation}>
                  {t('botaoCancelar')}
                </ModalCancel>
                <Button onClick={handleSubmitModal} variant="primary">{t('botaoSalvar')}</Button>
              </Flex>
            </>
          )}
        </ModalWindow>
      )}
    </Background>
  );
};

interface IMenuLogo {
  menuToogle: boolean
  setMenuToogle: (value: boolean) => void
  setToogleAnalise: (value: boolean) => void
  setToggleAlerts: (value: boolean) => void
}

const MenuLogo = ({
  menuToogle,
  setMenuToogle,
  setToogleAnalise,
  setToggleAlerts,
} : IMenuLogo) : JSX.Element => (
  <LogoContainer isOpen={menuToogle}>
    <div>
      <CustomLogo style={{ marginTop: '19px', marginBottom: '27px' }} src={!menuToogle ? ExpandirMenu : MenuExpandido} alt="openOrClose" onClick={() => { setMenuToogle(!menuToogle); setToogleAnalise(false); setToggleAlerts(false); }} />
    </div>
    <InfoHeader>
      { menuToogle ? t('PRINCIPAL') : ' '}
    </InfoHeader>
  </LogoContainer>
);

interface IMenuLink {
  isActive: any
  name: string
  linkTo: string
  image?: any
  altImage?: string
  Icon?: React.ComponentType<{ color?: string; size?: number | string }>
  click?: any
  subItem?: boolean
  menuToogle: boolean
  visible: boolean
  actions?: React.ReactNode
  isMobile?: boolean
  externalLink?: boolean
  isNew?: boolean
}

export const MenuLink = ({
  isActive,
  name,
  linkTo,
  image,
  Icon,
  actions,
  altImage,
  click,
  subItem,
  menuToogle,
  visible,
  isMobile,
  externalLink,
  isNew,
} : IMenuLink) : JSX.Element => {
  if (!visible) {
    return (
      <>
      </>
    );
  }
  if (!menuToogle) {
    return (
      <StyledLink to={linkTo} onClick={click}>
        <MenuItem isOpen={menuToogle} isActive={isActive} isMobile={isMobile}>
          <MenuItemImg src={image} alt={altImage} />
          <MenuHighlight isActive={isActive} />
        </MenuItem>
      </StyledLink>
    );
  }
  return (
    <StyledLink to={linkTo} onClick={click}>
      {
        subItem
          ? (
            <>
              <SubItemMenu isActive={isActive}>
                <BorderHorizontalSubItem />
                {Icon && (
                  <SubItemIcon>
                    <Icon size={16} />
                  </SubItemIcon>
                )}
                <MenuSubItemName>{name}</MenuSubItemName>
                {isNew === true && (<NewBadge style={{ fontSize: '14px' }}>{t('novo')}</NewBadge>)}
                <SubItemHighlight isActive={isActive} />
              </SubItemMenu>
            </>
          )
          : (
            <MenuItem isOpen={menuToogle} isActive={isActive} isMobile={isMobile}>
              <div>
                <MenuItemImg src={image} alt={altImage} />
                <MenuItemName>{name}</MenuItemName>
              </div>
              <MenuHighlight isActive={isActive} />
              {actions}
            </MenuItem>
          )
      }
    </StyledLink>
  );
};

const MenuWrapper = withRouter(Menu);
export { MenuWrapper as Menu };
